/*eslint-disable*/
export default page => {
  $(window).load(() => {
    $(page).find('h1, h3, p, .broken-text').addClass('active')
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/404-animate.js